import React from "react";


//MainTemplate
import MainTemplate from "./MainTemplate";


//scss
import "../scss/common.scss";
import "../scss/component.scss";
import ServiceStop from "./ServiceStop";

const PageServiceStop: React.FC = () => {

  return (
    <MainTemplate title="" logo={undefined} sellerId={undefined} supportDial={undefined} planSelectFormData={undefined}>

      <ServiceStop></ServiceStop>
           
    </MainTemplate>
  );
};

export default PageServiceStop;
